import { Icon, IconProps } from "@iconify/react";

const getIconProps = (extension: string): { icon: IconProps["icon"]; color: IconProps["color"] } => {
  switch (true) {
    case ["svg", "png", "jpg", "jpeg", "bmp", "gif", "psd"].includes(extension):
      return {
        icon: "ph:file-image-fill",
        color: "#EE4266",
      };
    case ["mp4", "m4p", "m4v", "mpg", "mpeg", "avi", "flv"].includes(extension):
      return {
        icon: "ph:file-video-fill",
        color: "#540D6E",
      };
    case ["mp3", "wav", "wma", "aac"].includes(extension):
      return {
        icon: "ph:file-audio-fill",
        color: "#FFD23F",
      };
    case ["doc", "docx"].includes(extension):
      return {
        icon: "ph:microsoft-word-logo-fill",
        color: "#175ABD",
      };
    case ["csv", "xls", "xlsx"].includes(extension):
      return {
        icon: "ph:microsoft-excel-logo-fill",
        color: "#0E7C41",
      };
    case ["ppt", "pptx"].includes(extension):
      return {
        icon: "ph:microsoft-powerpoint-logo-fill",
        color: "#C43E1B",
      };
    case ["pdf"].includes(extension):
      return {
        icon: "ant-design:file-pdf-filled",
        color: "#EB1100",
      };
    default:
      return {
        icon: "ph:file-fill",
        color: "#343a40",
      };
  }
};

interface Props extends Partial<IconProps> {
  name: string;
}

export function FileIcon({ name, ...props }: Props) {
  const extension = name.substring(name.lastIndexOf(".") + 1);
  const { icon, color } = getIconProps(extension);

  return <Icon icon={icon} color={color} {...props} />;
}
